<template>
  <div class="pre-receipt-wrapper">
    <div class="filter-row">
      <el-select v-model="filterStatus" size="small" placeholder="票据状态" clearable @change="loadData" style="width:120px">
        <el-option label="全部" value="" />
        <el-option label="预收票据" value="1001" />
        <el-option label="已确认" value="0" />
        <el-option label="已作废" value="2002" />
      </el-select>
      <span class="tip-text">提示：确认收款将直接生成缴费记录和正式收据；作废后不可恢复</span>
    </div>

    <el-table
      :data="groupedList"
      border
      size="small"
      v-loading="loading"
      style="margin-top:8px"
      row-key="receiptId"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.details" border size="small" style="margin:4px 20px">
            <el-table-column label="费用名称" min-width="110">
              <template slot-scope="s">{{ s.row.feeName }}</template>
            </el-table-column>
            <el-table-column label="房屋/车牌" min-width="110">
              <template slot-scope="s">{{ _getObjDisplay(s.row) }}</template>
            </el-table-column>
            <el-table-column prop="startTime" label="开始时间" width="110" align="center">
              <template slot-scope="s">
                {{ (s.row.startTime || '').substring(0, 10) }}
              </template>
            </el-table-column>
            <el-table-column prop="endTime" label="结束时间" width="110" align="center">
              <template slot-scope="s">
                {{ (s.row.endTime || '').substring(0, 10) }}
              </template>
            </el-table-column>
            <el-table-column label="金额" width="100" align="center">
              <template slot-scope="s">
                ¥{{ _fmt(s.row.amount) }}
              </template>
            </el-table-column>
            <el-table-column prop="cycle" label="周期" width="80" align="center" />
            <el-table-column prop="remark" label="备注" min-width="100" show-overflow-tooltip />
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="收据编号" width="150" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.statusCd === '1001'" type="warning" size="mini">预收</el-tag>
          <el-tag v-else-if="scope.row.statusCd === '2002'" type="danger" size="mini">作废</el-tag>
          <el-tag v-else type="success" size="mini">已确认</el-tag>
          {{ scope.row.receiptCode }}
        </template>
      </el-table-column>
      <el-table-column prop="payObjName" label="付费对象" min-width="100" align="center" />
      <el-table-column label="金额" width="100" align="center">
        <template slot-scope="scope">
          <b :class="scope.row.statusCd === '2002' ? 'text-muted' : 'text-warning'">¥{{ _fmt(scope.row.totalAmount) }}</b>
        </template>
      </el-table-column>
      <el-table-column label="明细数" width="80" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" type="info">{{ scope.row.detailCount }}项</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160" align="center">
        <template slot-scope="scope">
          {{ (scope.row.createTime || '').substring(0, 16) }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="100" align="center" show-overflow-tooltip />
      <el-table-column label="操作" width="190" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" icon="el-icon-printer" @click="_print(scope.row)">打印</el-button>
          <el-button v-if="scope.row.statusCd === '1001'" type="text" size="mini" icon="el-icon-check" @click="_openPayDialog(scope.row)">确认收款</el-button>
          <el-button v-if="scope.row.statusCd === '1001'" type="text" size="mini" icon="el-icon-close" style="color:#F56C6C" @click="_voidReceipt(scope.row)">作废</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="!loading && groupedList.length === 0" class="empty-tip">暂无预收票据</div>

    <el-pagination
      v-if="total > 0"
      style="margin-top:12px;text-align:right"
      background layout="total,prev,pager,next"
      :total="total" :page-size="pageSize" :current-page.sync="currentPage"
      @current-change="loadData" />

    <!-- 收款方式选择对话框 -->
    <el-dialog
      title="确认收款"
      :visible.sync="payDialogVisible"
      width="420px"
      :close-on-click-modal="false"
    >
      <el-form :model="payForm" label-width="80px" size="small">
        <el-form-item label="收据编号">
          <span class="form-text">{{ payForm.receiptCode }}</span>
        </el-form-item>
        <el-form-item label="收款金额">
          <span class="form-text-amount">¥{{ _fmt(payForm.totalAmount) }}</span>
        </el-form-item>
        <el-form-item label="明细数量">
          <span class="form-text">{{ payForm.detailCount }} 项</span>
        </el-form-item>
        <el-form-item label="收款方式" required>
          <el-select v-model="payForm.primeRate" placeholder="请选择收款方式" style="width:100%">
            <el-option
              v-for="item in primeRates"
              :key="item.statusCd"
              :label="item.name"
              :value="item.statusCd"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="payForm.remark" type="textarea" :rows="2" placeholder="选填" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="payDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="paySubmitting" @click="_doConfirmPay">确认收款</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId, getDict } from '@/api/community/communityApi'
import { queryPreReceipt, confirmPreReceipt, confirmPreReceiptWithPay } from '@/api/fee/preReceiptApi'

export default {
  name: 'SimplifyPreReceipt',
  data() {
    return {
      communityId: '',
      filterStatus: '',
      receiptList: [],
      groupedList: [],
      loading: false,
      total: 0,
      pageSize: 15,
      currentPage: 1,
      roomId: '',
      roomName: '',
      carId: '',
      carNum: '',
      ownerId: '',
      // 当前付费对象类型：3333=房屋 / 6666=车辆
      objType: '3333',
      // 收款对话框
      payDialogVisible: false,
      paySubmitting: false,
      payForm: {
        receiptId: '',
        receiptCode: '',
        totalAmount: 0,
        detailCount: 0,
        primeRate: '',
        remark: ''
      },
      primeRates: []
    }
  },
  methods: {
    open(param) {
      this.roomId = param.roomId || ''
      this.roomName = param.roomName || ''
      this.carId = param.carId || ''
      this.carNum = param.carNum || ''
      this.ownerId = param.ownerId || ''
      // 优先房屋，其次车辆；决定 objId 与 objType
      if (this.roomId) {
        this.objType = '3333'
      } else if (this.carId) {
        this.objType = '6666'
      }
      this.communityId = getCommunityId()
      this.currentPage = 1
      this._loadPrimeRates()
      this.loadData()
    },
    /** 加载收款方式字典 */
    async _loadPrimeRates() {
      try {
        this.primeRates = await getDict('pay_fee_detail', 'prime_rate')
      } catch (e) {
        console.error('获取收款方式字典失败', e)
      }
    },
    async loadData() {
      this.loading = true
      try {
        // objId：房屋用 roomId，车辆用 carId
        const objId = this.objType === '6666' ? this.carId : this.roomId
        const params = {
          page: this.currentPage,
          row: this.pageSize,
          communityId: this.communityId,
          objId: objId || '',
          objType: this.objType
        }
        if (this.filterStatus) {
          params.statusCd = this.filterStatus
        }
        const res = await queryPreReceipt(params)
        console.log('应收票据查询结果:', res)
        if (res.code === 0) {
          const list = Array.isArray(res.data) ? res.data : (res.records || [])
          const filtered = list.filter(r => r.statusCd === '1001' || r.statusCd === '2002')
          this.receiptList = filtered
          this.groupedList = this._mergeByReceiptId(filtered)
          this.total = this.groupedList.length
        }
      } catch (e) {
        console.error('查询预收票据失败', e)
      } finally {
        this.loading = false
      }
    },
    _mergeByReceiptId(list) {
      const map = {}
      list.forEach(item => {
        const key = item.receiptId
        // detailAmount 是 SQL 新增的明细级金额字段，amount 仍是收据级（INNER JOIN 多行相同），
        // receivableAmount 是收据应收总额
        if (!map[key]) {
          map[key] = {
            receiptId: item.receiptId,
            receiptCode: item.receiptCode,
            payObjId: item.payObjId,
            payObjName: item.payObjName,
            objId: item.objId,
            objName: item.objName,
            objType: item.objType,
            statusCd: item.statusCd,
            createTime: item.createTime,
            remark: item.remark,
            totalAmount: parseFloat(item.receivableAmount || item.amount || 0),
            detailCount: 0,
            details: []
          }
        }
        map[key].detailCount++
        map[key].details.push({
          feeName: item.feeName || '',
          amount: item.detailAmount || item.amount || '0',
          startTime: item.startTime || '',
          endTime: item.endTime || '',
          cycle: item.cycle || '',
          feeId: item.feeId || '',
          remark: item.remark || '',
          // 对象信息：objName=房屋号/车牌，objType=3333房屋/6666车辆，用于明细展示
          objName: item.objName || item.roomName || '',
          objType: item.objType || '',
          carNum: item.carNum || ''
        })
        if (!map[key].remark && item.remark) {
          map[key].remark = item.remark
        }
      })
      return Object.values(map)
    },
    _print(row) {
      // 只打印当前点击的这一张收据
      window.open(`/#/pages/property/printPayFee?receiptId=${row.receiptId}&apply=N`, '_blank')
    },
    /** 打开收款方式选择对话框 */
    _openPayDialog(row) {
      this.payForm = {
        receiptId: String(row.receiptId || ''),
        receiptCode: row.receiptCode,
        totalAmount: row.totalAmount,
        detailCount: row.detailCount,
        primeRate: '',
        remark: ''
      }
      console.log('[_openPayDialog] receiptId=', this.payForm.receiptId, 'type=', typeof this.payForm.receiptId)
      this.payDialogVisible = true
    },
    /** 执行确认收款 */
    async _doConfirmPay() {
      if (!this.payForm.primeRate) {
        this.$message.warning('请选择收款方式')
        return
      }
      this.paySubmitting = true
      try {
        const reqData = {
          communityId: String(this.communityId),
          receiptId: String(this.payForm.receiptId),
          primeRate: this.payForm.primeRate,
          remark: this.payForm.remark
        }
        console.log('[_doConfirmPay] 请求参数:', JSON.stringify(reqData))
        console.log('[_doConfirmPay] receiptId type:', typeof reqData.receiptId, 'value:', reqData.receiptId)
        const res = await confirmPreReceiptWithPay(reqData)
        if (res.code === 0) {
          this.$message.success('收款成功，已生成缴费记录和正式收据')
          this.payDialogVisible = false
          this.loadData()
        } else {
          this.$message.error(res.msg || '收款失败')
        }
      } catch (e) {
        this.$message.error('收款失败')
        console.error(e)
      } finally {
        this.paySubmitting = false
      }
    },
    async _voidReceipt(row) {
      try {
        await this.$confirm('确认作废该预收票据？作废后不可恢复。', '作废确认', {
          confirmButtonText: '确定作废',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch { return }
      try {
        const res = await confirmPreReceipt({
          communityId: String(this.communityId),
          receiptId: String(row.receiptId || ''),
          action: 'void'
        })
        if (res.code === 0) {
          this.$message.success('已作废')
          this.loadData()
        } else {
          this.$message.error(res.msg || '作废失败')
        }
      } catch (e) {
        this.$message.error('作废失败')
        console.error(e)
      }
    },
    _fmt(val) {
      return parseFloat(val || 0).toFixed(2)
    },
    // 明细的对象显示：车辆(6666)优先显示车牌，房屋(3333)显示房屋号
    _getObjDisplay(row) {
      // 车牌优先：carNum 或从 objName 提取车牌
      if (row.carNum && row.carNum !== '-') return row.carNum
      const name = row.objName || ''
      if (name && name !== '-') {
        // objName 已是车牌格式则直接用
        if (/[一-龥][A-Z][A-HJ-NP-Z0-9]{4,6}/.test(name)) return name
        return name // 房屋号等其它对象名
      }
      return '-'
    }
  }
}
</script>

<style scoped>
.pre-receipt-wrapper { padding: 4px 0; }
.filter-row { display: flex; align-items: center; gap: 12px; }
.tip-text { color: #909399; font-size: 12px; }
.text-warning { color: #E6A23C; }
.text-muted { color: #C0C4CC; text-decoration: line-through; }
.empty-tip { text-align: center; color: #909399; padding: 40px 0; }
.form-text { font-size: 14px; color: #303133; }
.form-text-amount { font-size: 16px; font-weight: bold; color: #E6A23C; }
</style>
